import { useState } from "react";
import { Logo } from "./Logo";
import { scrollToId, openQuote } from "../lib/lenis";

const LINKS = [
  { id: "services", label: "Services" },
  { id: "proof", label: "Backstage" },
  { id: "about", label: "About" },
  { id: "technique", label: "Method" },
  { id: "testimonials", label: "Word of Mouth" },
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-ink/80 backdrop-blur-xl border-b border-white/10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-mute hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            data-testid="nav-quote-button"
            onClick={() => openQuote("corporate")}
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-gold px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.18em] text-ink font-medium transition-all duration-300 hover:bg-ivory hover:shadow-[0_0_32px_rgba(212,175,55,0.35)]"
          >
            Request a Quote
          </button>
          <button
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
            aria-expanded={open}
            onClick={() => setOpen(!open)}
            className="md:hidden rounded-full border border-white/15 p-2.5 text-ivory"
          >
            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" aria-hidden="true">
              {open
                ? <path d="M2 2l14 10M16 2L2 12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                : <path d="M1 1h16M1 7h16M1 13h16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />}
            </svg>
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t border-white/10 bg-ink/95 backdrop-blur-xl" data-testid="nav-mobile-menu">
          <nav className="px-6 py-5 flex flex-col gap-4" aria-label="Mobile">
            {LINKS.map((l) => (
              <button key={l.id} data-testid={`nav-mobile-link-${l.id}`} onClick={() => go(l.id)}
                className="text-left font-serif text-2xl text-ivory">
                {l.label}
              </button>
            ))}
            <button data-testid="nav-mobile-quote-button" onClick={() => { setOpen(false); openQuote("corporate"); }}
              className="mt-2 rounded-full bg-gold px-5 py-3 font-mono text-[11px] uppercase tracking-[0.18em] text-ink font-medium">
              Request a Quote
            </button>
          </nav>
        </div>
      )}
    </header>
  );
};
